import { TeamDataObject } from "../DataStorage/TeamDataObject";
import { FlowStorageHistory } from "./FlowStorageHistory";
import { IUserInfo } from "../DataStorage/IUserInfo";
import { FlowStorageHistoryType } from "./FlowStorageHistoryType";
import { FlowState } from "./FlowState";
import { FlowStorageResumeType } from "./FlowStorageResumeType";

export class FlowStorageData extends TeamDataObject {
    flowExecutionId: string;
    flowId: string;
    flowExecutionData: object;
    flowState: FlowState = FlowState.RUNNING;

    errorDetails?: string;
    completedDate?: Date;
    clearAfterDate?: Date;

    waitingOnResume: FlowStorageResumeType = FlowStorageResumeType.NONE;
    clientResumeUserEmail?: string;
    clientResumeClientId?: string;

    resumeWhen?: Date;

    history: FlowStorageHistory[] = [];

    constructor(
        user: IUserInfo,
        flowExecutionId: string,
        flowId: string,
        createdDate: Date,
        modifiedDate: Date,
        data: object
    ) {
        super();
        this.flowExecutionId = flowExecutionId;
        this.flowId = flowId;
        this.flowExecutionData = data;

        this.history.push(new FlowStorageHistory(new Date(), FlowStorageHistoryType.CREATED, user.userEmail, ""));
    }
}
